import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  
  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Features', path: '/features' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];
  
  return (
    <header className="w-full py-6 px-6 bg-white/80 backdrop-blur-sm border-b border-gray-200/50 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2 cursor-pointer">
          <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-lg flex items-center justify-center">
            <i className="ri-search-line text-white text-lg"></i>
          </div>
          <span className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Pacifico, serif' }}>QikFinder</span>
        </Link>
        
        <nav className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`font-medium transition-colors cursor-pointer ${
                location.pathname === item.path
                  ? 'text-blue-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              {item.name}
            </Link>
          ))}
        </nav>
        
        <div className="md:hidden">
          <button className="w-8 h-8 flex items-center justify-center cursor-pointer">
            <i className="ri-menu-line text-gray-600 text-xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
}